import { Wallet, Loader2 } from 'lucide-react'
import { useAuthStore } from '@/lib/store'
import { useApiQuery } from '@/hooks/use-api-query'
import { GetAuthenticatedTenantUser } from '@/queries/get-authenticated-tenant-user.query'
import { GetTenantBalance } from '@/queries/get-tenant-balance.query'
import TokenAmount from './TokenAmount'

export function BalanceDisplay() {
  const { user } = useAuthStore()
  const isRootAdmin = user?.role === 'root_admin'

  const { data: tenantUser } = useApiQuery(GetAuthenticatedTenantUser(), {
    enabled: Boolean(user) && user?.type === 'tenant',
  })
  const { data: tenantBalance, isLoading: balanceLoading } = useApiQuery(
    GetTenantBalance({ tenantId: tenantUser?.id?.toString() ?? '' }),
    {
      enabled: user?.type === 'tenant' && !isRootAdmin && !!tenantUser?.id,
    },
  )

  const tenantName = user?.type === 'tenant' ? tenantUser?.tenantName : 'Portafino'

  if (isRootAdmin) {
    return null
  }

  return (
    <div className="px-4 py-3 border-b border-border bg-primary/5">
      {isRootAdmin ? (
        <div>
          <div className="text-sm font-medium mb-1">Current Balance</div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              <Wallet className="h-3.5 w-3.5 text-primary" />
              <span className="text-sm">
                {/* TODO: Fetch root admin balance */}
                <TokenAmount amount={0n} />
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-sm font-medium mb-1">{tenantName}</div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              <Wallet className="h-3.5 w-3.5 text-primary" />
              {balanceLoading ? (
                <div className="flex items-center gap-1">
                  <Loader2 className="h-3 w-3 animate-spin" />
                  <span className="text-sm">Loading...</span>
                </div>
              ) : (
                <span className="text-sm">
                  <TokenAmount amount={tenantBalance?.balance} />
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
